// codegenNativeComponent shim for web compatibility
// This is used by native modules like react-native-safe-area-context
// On web, we just return a no-op component factory

import React from 'react';
import { View } from 'react-native';

function codegenNativeComponent<T>(componentName: string): React.ComponentType<T> {
  // Return a View component instead of a raw div to avoid CSS style issues
  // This is a shim for native codegen components on web
  const Component: React.ComponentType<T> = (props: any) => {
    // Extract children and other props, but use View which handles styles properly
    const { children, ...restProps } = props || {};
    return React.createElement(View, restProps, children);
  };
  
  Component.displayName = componentName;
  return Component;
}

export default codegenNativeComponent;

